module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00365.54eb2d88.jpg";